<!-- Information Modal -->
<div class="modal-header">
    <h5 class="modal-title">Join a Class</h5>
    <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p class="rosterModal__body__description">
        You're invited to join: <br />
        <strong> {{ classInvitation }} </strong>
    </p>
    <form name="joinClassForm" class="form-horizontal" role="form">
        <div class="form-group">
            <div class="col-sm-16">
                <input
                    type="text"
                    class="form-control"
                    id="student-name-input"
                    placeholder="Enter Your Name"
                    [(ngModel)]="student"
                    #studentName="ngModel"
                    name="studentName"
                    required
                />
            </div>
        </div>
    </form>
    <p>
        By joining this class, you agree to allow the teacher of this class access to your student
        login information.
    </p>
</div>
<div class="modal-footer">
    <input
        type="submit"
        value="Join Class"
        class="btn btn-primary"
        (click)="joinClass()"
        [disabled]="studentName.invalid"
        data-dismiss="modal"
    />
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cross click')">
        OK
    </button>
</div>
